export function updateViewportOnTrackPointerDown(event, track, viewport, audioDuration) {
	const rect = track.getBoundingClientRect();
	const x = event.clientX - rect.left;
	const trackWidth = track.clientWidth;
	const visibleSec = viewport.endSec - viewport.startSec;
	const maxStart = Math.max(0, audioDuration - visibleSec);
	const leftRatio = x / trackWidth;

	const centerSec = leftRatio * audioDuration;
	let newStart = centerSec - visibleSec / 2;
	newStart = Math.max(0, Math.min(maxStart, newStart));
	const viewportStartSec = newStart;
	const viewportEndSec = newStart + visibleSec;

	return {
		viewportStartSec,
		viewportEndSec
	};
}

export function releasePointerOnPointerUp(event, thumb) {
	if (thumb && thumb.releasePointerCapture) {
		thumb.releasePointerCapture(event.pointerId);
	}
}

export function updateViewportOnPointerMove(event, track, thumb, dragStartX, viewport, thumbStartLeft, audioDuration) {
	const dx = event.clientX - dragStartX;
	const trackWidth = track.clientWidth;
	const thumbWidth = thumb ? thumb.clientWidth : Math.max(1, trackWidth * viewport.fraction);
	let newLeft = thumbStartLeft + dx;
	newLeft = Math.max(0, Math.min(trackWidth - thumbWidth, newLeft));
	const leftRatio = newLeft / Math.max(1, trackWidth - thumbWidth);
	const visibleSec = viewport.endSec - viewport.startSec;
	const maxStart = Math.max(0, audioDuration - visibleSec);
	const viewportStartSec = leftRatio * maxStart;
	const viewportEndSec = viewportStartSec + visibleSec;

	return {
		viewportStartSec,
		viewportEndSec
	};
}

export function updateScrollbarPointerDown(event, thumb) {
	const dragStartX = event.clientX;
	const thumbStartLeft = thumb ? thumb.offsetLeft : 0;
	if (thumb) thumb.setPointerCapture(event.pointerId);

	return {
		dragStartX,
		thumbStartLeft
	};
}
